import React from 'react';
import { IoBagAdd } from 'react-icons/io5';
import { motion } from 'framer-motion';
import { FaBullhorn } from 'react-icons/fa';

const CreateCampaignCard = ({
  onClick,
  btnText,
  heading,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      whileHover={{ y: -2 }}
      className="rounded-2xl border border-transparent backdrop-blur-md shadow-xl px-5 py-4"
      style={{
        background:
          "linear-gradient(160deg, #ffffff 0%, #f5faff 100%) padding-box, linear-gradient(125deg, rgba(130, 168, 216, 0.45) 0%, rgba(122, 163, 214, 0.45) 50%, rgba(140, 180, 226, 0.45) 100%) border-box",
        boxShadow: "0 12px 24px rgba(23, 61, 111, 0.12)",
      }}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <motion.div
            animate={{ scale: [1, 1.08, 1], rotate: [0, -8, 8, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
            className="h-12 w-12 rounded-xl grid place-items-center text-white shadow-md ring-1 ring-blue-200 shrink-0"
            style={{ backgroundImage: 'linear-gradient(120deg, #4f46e5 0%, #2563eb 100%)' }}
          >
            <FaBullhorn className="text-[20px]" />
          </motion.div>
          <div className="min-w-0">
            <h2 className="text-base font-extrabold text-[#153f71] tracking-wide truncate">{heading}</h2>
          </div>
        </div>

        <motion.button
          type="button"
          onClick={onClick}
          whileHover={{ y: -2, scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="flex items-center gap-2 rounded-xl px-4 py-2 text-white font-semibold shadow-md transition hover:opacity-90 ring-1 ring-white/20 whitespace-nowrap"
          style={{ backgroundImage: 'linear-gradient(120deg, #6366f1 0%, #2563eb 100%)' }}
        >
          <IoBagAdd size={20} />
          <span>{btnText}</span>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default CreateCampaignCard;
